module.exports = __webpack_public_path__ + "static/pinkfloralmain-98c7aa75f0069ed0ea428fb1f9468f64.png";